import React from 'react';
import SiteMobileHeader from '../components/SiteMobileHeader';
import HomeContactFooter from '../components/HomeContactFooter';
import NewsArticleCard from '../components/NewsArticleCard';
import gulfNewsLogo from '../assets/shared/press/gulf-news-logo.svg';
import { pressNewsImage } from '../cdn/pressMedia';
import './LandingPage.css';

const NEWS_ITEMS = Array.from({ length: 3 }, (_, idx) => ({
  id: idx + 1,
  title: 'Neoterra Developments breaks ground for ELMORA',
  summary: 'We celebrate diverse talents and believe great work happens when people feel supported.',
}));

const NewsPage = () => {
  return (
    <div className="landing-page min-h-screen bg-[#efefef]">
      <SiteMobileHeader barClassName="home-top-bar" />

      <section className="relative min-h-screen w-full bg-[#fbfaf7] pt-[104px]" aria-label="News page">
        <div className="mx-auto w-full max-w-none px-6 pb-4 md:max-w-[1200px] md:px-6 lg:px-8">
          <div className="grid grid-cols-1 items-stretch gap-[22px] md:grid-cols-3 md:gap-6 lg:gap-8">
            {NEWS_ITEMS.map((item) => (
              <div key={item.id} className="h-full">
              <NewsArticleCard
                key={item.id}
                className="rounded-[12px]"
                titleClassName="font-normal"
                summaryClassName="font-normal"
                publisherLogoSrc={gulfNewsLogo}
                imageSrc={pressNewsImage}
                title={item.title}
                summary={item.summary}
              />
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="relative z-[20] isolate bg-[#FFFFFF]">
        <HomeContactFooter sectionId="news-contact" />
      </div>
    </div>
  );
};

export default NewsPage;
